module.exports = __webpack_public_path__ + "img/collection-weddingRingsSignature.53cf8c7.webp";